export const queryKeys = {
  branding: ['branding'] as const,

  vessels: {
    all: ['vessels'] as const,
    detail: (id: string) => ['vessels', id] as const,
    light: (filters: Record<string, unknown>) => ['vessels', 'light', filters] as const,
  },

  holdings: {
    byVessel: (vesselId: string) => ['holdings', vesselId] as const,
    services: (vesselId: string) => ['holdings', 'services', vesselId] as const,
  },

  updates: {
    byVessel: (vesselId: string, filters: Record<string, unknown>) =>
      ['updates', vesselId, filters] as const,
  },

  updateWeeks: {
    avcs: (params?: Record<string, unknown>) => ['updateWeeks', 'avcs', params] as const,
  },

  catalog: {
    all: (params?: Record<string, unknown>) => ['catalog', params] as const,
    categories: ['catalog', 'categories'] as const,
  },

  orders: {
    all: ['orders'] as const,
    detail: (id: string) => ['orders', id] as const,
    b2bHistory: (orderId: string) => ['orders', orderId, 'b2b-history'] as const,
  },

  routes: {
    byVessel: (vesselId: string) => ['routes', vesselId] as const,
    detail: (routeId: string) => ['routes', 'detail', routeId] as const,
    products: (routeId: string) => ['routes', routeId, 'products'] as const,
  },

  ports: {
    all: ['ports', 'all'] as const,
    search: (query: string) => ['ports', query] as const,
  },

  vesselPosition: ['vessels', 'position'] as const,

  countries: {
    all: ['countries'] as const,
  },

  lookups: {
    vesselTypes: ['lookups', 'vessel-types'] as const,
  },

  holdingTemplates: {
    all: ['holding-templates'] as const,
    list: (filters: Record<string, unknown>) =>
      ['holding-templates', 'list', filters] as const,
    detail: (id: string) => ['holding-templates', id] as const,
    effectiveForVessel: (vesselId: string) =>
      ['holding-templates', 'effective', vesselId] as const,
  },

  admin: {
    tenants: {
      all: ['admin', 'tenants'] as const,
      tree: ['admin', 'tenants', 'tree'] as const,
      list: (filters: Record<string, unknown>) => ['admin', 'tenants', 'list', filters] as const,
      detail: (id: string) => ['admin', 'tenants', id] as const,
      relations: (id: string) => ['admin', 'tenants', id, 'relations'] as const,
      users: (id: string) => ['admin', 'tenants', id, 'users'] as const,
    },
    authUsers: {
      all: ['admin', 'auth-users'] as const,
      list: (filters: Record<string, unknown>) => ['admin', 'auth-users', 'list', filters] as const,
      detail: (id: string) => ['admin', 'auth-users', id] as const,
      assignments: (id: string) => ['admin', 'auth-users', id, 'assignments'] as const,
    },
    resourceAccess: {
      all: ['admin', 'resource-access'] as const,
      list: (filters: Record<string, unknown>) => ['admin', 'resource-access', 'list', filters] as const,
    },
    onboarding: {
      all: ['admin', 'onboarding'] as const,
      list: (filters: Record<string, unknown>) => ['admin', 'onboarding', 'list', filters] as const,
      detail: (id: string) => ['admin', 'onboarding', id] as const,
    },
  },
} as const;
